export const MobilePlayer: React.FC = () => {
  return (
    <div className="mobile-warning-container">
      <span>Game play accessible only on desktop.</span>
    </div>
  );
};
